import { icxeedDifference } from "../data/icxeeddifference";
import { clientVertical } from "../data/clientverticals";
import { useCasesCards } from "../data/useCasesSlider";
import { useCaseCard } from "../data/caseStudySlider";
import { testimonials } from "../data/testimonials";
import { testimonialsAws } from "../data/testimonialsAws";

import LoginCard from "../components/LoginCard";
import NavigationBlock from "../components/NavigationBlock";
import HeroSectionBlk from "../components/HeroSectionBlk";
import TabSectionBlk from "../components/TabSectionBlk";
import UseCasesSectionBlk from "../components/UseCasesSectionBlk";
import CardSliderSectionBlk from "../components/CardSliderSectionBlk";
import CardSliderCaseStudies from "../components/CardSliderCaseStudies";
import { VideosAndDemosSection } from "../components/VideosAndDemosSection";
import TestimonialSectionBlk from "../components/TestimonialSectionBlk";
import KeyContactsSectionBlk from "../components/KeyContactsSectionBlk";
import AccordionSectionBlk from "../components/AccordionSectionBlk";
import AskIrisSectionBlk from "../components/AskIrisSectionBlk";
import IrisChatBotBlk from "../components/IrisChatBotBlk";
import FooterPage from "../components/FooterPage";
import DFFACBannerSection from "../components/DFFACBannerSection";
import { ClientStoriesSection } from "../components/ClientStoriesSection";

type Props = {
  isLoggedIn: boolean;
  isAskIrisVisible: boolean;
};

export const HomePage = ({ isLoggedIn, isAskIrisVisible }: Props) => {
  if (!isLoggedIn) return <LoginCard />;

  return (
    <div className="iris-container-page">
      <NavigationBlock />
      <HeroSectionBlk />

      <section id="icxeed-difference" className="pt-[72px]">
        <TabSectionBlk title="iCXeed Difference" tabs={icxeedDifference} />
      </section>

      <section id="clientele-verticals" className="pt-[72px]">
        <TabSectionBlk title="Clientele & Verticals" tabs={clientVertical} />
      </section>

      <DFFACBannerSection />

      <ClientStoriesSection />

      <section id="use-cases">
        <UseCasesSectionBlk
          title="Use Cases / Battlecards"
          description="Explore iCXeed's essential battlecards - a curated set of use cases, best practice guides, and rapid-deployment solutions for CX, Contact Centre, and AI transformation."
          videoBg={true}
        />
        <CardSliderSectionBlk
          cards={(useCasesCards ?? []).map((c) => ({
            ...c,
            image: c.image ?? "",
          }))}
        />

        <UseCasesSectionBlk
          title="Case Studies"
          description="See the impact, from rapid implementations to scalable innovation, across diverse sectors and challenges "
          videoBg={false}
        />
        <CardSliderCaseStudies cards={useCaseCard ?? []} />

        <VideosAndDemosSection />
      </section>

      <section id="client-testimonials">
        <TestimonialSectionBlk
          testimonials={testimonials}
          title="Client Testimonials"
          isPaused={isAskIrisVisible}
        />
        <TestimonialSectionBlk
          testimonials={testimonialsAws}
          title="AWS Testimonials"
          isPaused={isAskIrisVisible}
        />
      </section>
      <div id="trigger"></div>
      <section id="key-contacts">
        <KeyContactsSectionBlk />
        <AccordionSectionBlk />
      </section>

      <section id="ask-iris">
        <AskIrisSectionBlk />
      </section>

      <IrisChatBotBlk />

      <FooterPage />
    </div>
  );
};
